import { redirect } from "@tanstack/react-router";
import type { ShopFeatureFlagId } from "@/modules/merchant/domain/contracts/shop-feature-flags";
import { hasShopFeature } from "@/modules/merchant/presentation/lib/has-shop-feature";
import { useMerchantShopsStore } from "@/modules/merchant/presentation/store/merchant-shops-store";

/** ถ้า feature ปิดสำหรับร้าน — redirect ไปแดชบอร์ดร้าน */
export function ensureShopFeature(
  shopId: string | undefined,
  feature: ShopFeatureFlagId,
): void {
  if (!shopId) return;
  const shop = useMerchantShopsStore.getState().getShop(shopId);
  if (shop && !hasShopFeature(shop.featureFlags, feature)) {
    throw redirect({
      to: "/app/shops/$shopId",
      params: { shopId },
    });
  }
}
